export const bekendePersonen = [
  "Albert Einstein",
  "Leonardo da Vinci",
  "Marie Curie",
  "Nelson Mandela",
  "Mahatma Gandhi",
  "Martin Luther King Jr.",
  "Amelia Earhart",
  "Winston Churchill",
  "Rosa Parks",
  "Mother Teresa",
  "Pablo Picasso",
  "Vincent van Gogh",
  "Frida Kahlo",
  "William Shakespeare",
  "Charles Darwin",
  "Isaac Newton",
  "Galileo Galilei",
  "Stephen Hawking",
  "Jane Goodall",
  "Helen Keller",
  "Malala Yousafzai",
  "Oprah Winfrey",
  "Steve Jobs",
  "Bill Gates",
  "Mark Zuckerberg",
  "Elon Musk",
  "Barack Obama",
  "Nelson Mandela",
  "Walt Disney",
  "Steve Jobs",
  "Muhammad Ali",
  "Michael Jordan",
  "Serena Williams",
  "Usain Bolt",
  "Roger Federer",
  "Lionel Messi",
  "Cristiano Ronaldo",
  "Tom Hanks",
  "Meryl Streep",
  "Leonardo DiCaprio",
  "Robert De Niro",
  "Johnny Depp",
  "Brad Pitt",
  "Angelina Jolie",
  "Jennifer Aniston",
  "Julia Roberts",
  "Marilyn Monroe",
  "Audrey Hepburn",
  "Charlie Chaplin",
  "Alfred Hitchcock",
  "Steven Spielberg",
  "Christopher Nolan",
  "Quentin Tarantino",
  "Martin Scorsese",
  "Stan Lee",
  "J.K. Rowling",
  "George R.R. Martin",
  "Stephen King",
  "Dr. Seuss",
  "Roald Dahl",
  "Agatha Christie",
  "Jane Austen",
  "Charles Dickens",
  "Ernest Hemingway",
  "F. Scott Fitzgerald",
  "Toni Morrison",
  "Maya Angelou",
  "Virginia Woolf",
  "Emily Dickinson",
  "Sigmund Freud",
  "Carl Jung",
  "Marie Antoinette",
  "Queen Elizabeth II",
  "Cleopatra",
  "Joan of Arc",
  "Alexander the Great",
  "Julius Caesar",
  "Napoleon Bonaparte",
  "Abraham Lincoln",
  "George Washington",
  "Martin Luther",
  "Pope Francis",
  "Mahatma Gandhi",
  "Mao Zedong",
  "Winston Churchill",
  "Nelson Mandela",
  "John F. Kennedy",
  "Neil Armstrong",
  "Amelia Earhart",
  "Anne Frank",
  "Rosa Parks",
  "Hillary Clinton",
  "Michelle Obama",
  "Princess Diana",
  "Queen Victoria",
  "Mother Teresa",
  "Marie Curie",
  "Rosalind Franklin",
  "Ada Lovelace",
  "Grace Hopper",
  "Katherine Johnson",
  "Neil deGrasse Tyson",
  "Bill Nye",
  "Jane Goodall",
  "Jacques Cousteau",
  "David Attenborough",
  "Elvis Presley",
  "The Beatles",
  "Michael Jackson",
  "Bob Dylan",
  "Frank Sinatra",
  "Beyoncé",
  "Taylor Swift",
  "Rihanna",
  "Lady Gaga",
  "Kanye West",
  "Jay-Z",
  "Eminem",
  "David Bowie",
  "Prince",
  "Freddie Mercury",
  "Madonna",
  "Whitney Houston",
  "Amy Winehouse",
  "John Lennon",
  "Paul McCartney",
  "Oprah Winfrey",
  "Ellen DeGeneres",
  "Jimmy Fallon",
  "Stephen Colbert",
  "Conan O'Brien",
  "Trevor Noah",
  "Jon Stewart",
  "Michelle Obama",
  "Kate Middleton",
  "Meghan Markle",
  "Queen Elizabeth II",
  "Princess Diana",
  "Angelina Jolie",
  "Brad Pitt",
  "Tom Hanks",
  "Robert Downey Jr.",
  "Dwayne Johnson",
  "Will Smith",
  "Johnny Depp",
  "Ryan Reynolds",
  "Leonardo DiCaprio",
  "Emma Watson",
  "Jennifer Lawrence",
  "Scarlett Johansson",
  "Gal Gadot",
  "Meryl Streep",
  "Julia Roberts",
  "Nicole Kidman",
  "Charlize Theron",
  "Audrey Hepburn",
  "Grace Kelly",
  "Marilyn Monroe",
  "Elizabeth Taylor",
  "Natalie Portman",
  "Cate Blanchett",
  "Penélope Cruz",
  "Emma Stone",
  "Halle Berry",
  "Viola Davis",
  "Maggie Smith",
  "Al Pacino",
  "Robert De Niro",
  "Tom Hanks",
  "Denzel Washington",
  "Leonardo DiCaprio",
  "Morgan Freeman",
  "Anthony Hopkins",
  "Jack Nicholson",
  "Dustin Hoffman",
  "Sean Connery",
  "Clint Eastwood",
  "Robert Downey Jr.",
  "Johnny Depp",
  "Brad Pitt",
  "Hugh Jackman",
  "Ryan Reynolds",
  "Chris Hemsworth",
  "Tom Cruise",
  "Will Smith",
  "Keanu Reeves",
  "Matt Damon",
  "Christian Bale",
  "Russell Crowe",
  "Daniel Day-Lewis",
  "Joaquin Phoenix",
  "Dwayne Johnson",
  "Chris Evans",
  "Mark Ruffalo",
  "Robert Pattinson",
  "Benedict Cumberbatch",
  "Chadwick Boseman",
  "Idris Elba",
  "David Beckham",
  "Cristiano Ronaldo",
  "Lionel Messi",
  "Roger Federer",
  "Rafael Nadal",
  "Serena Williams",
  "Maria Sharapova",
  "Simone Biles",
  "Michael Phelps",
  "Usain Bolt",
  "Lewis Hamilton",
  "Sebastian Vettel",
  "Valentino Rossi",
  "Muhammad Ali",
  "Mike Tyson",
  "Floyd Mayweather Jr.",
  "Conor McGregor",
  "Manny Pacquiao",
  "Babe Ruth",
  "Michael Jordan",
  "LeBron James",
  "Kobe Bryant",
  "Tiger Woods",
  "Rory McIlroy",
  "Cristiano Ronaldo",
  "Lionel Messi",
  "Neymar",
  "Kylian Mbappé",
  "Virat Kohli",
  "Roger Federer",
  "Rafael Nadal",
  "Novak Djokovic",
  "Serena Williams",
  "Naomi Osaka",
  "Simone Biles",
  "Megan Rapinoe",
  "Alex Morgan",
  "Lindsey Vonn",
  "Skiel Bumpus",
  "Stella Davis",
  "Aiden Powers",
  "Nina Snow",
  "Jameson Ford",
  "Olivia Harper",
  "Mila Wilson",
];
